// frontend/components/sidebar/DeleteModal.tsx

interface DeleteModalProps {
    visible: boolean;
    title: string;
    onClose: () => void;
    onSubmit: () => void;
  }
  
  // 문서 삭제 경고 모달 렌더링
  export default function DeleteModal({ visible, title, onClose, onSubmit }: DeleteModalProps) {
    if (!visible) return null;
  
    return (
      <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in" onClick={onClose}>
        <div className="bg-white dark:bg-zinc-900 p-5 rounded-xl shadow-2xl w-80 border dark:border-zinc-800 animate-in zoom-in-95" onClick={e => e.stopPropagation()}>
          <h3 className="text-sm font-bold text-gray-800 dark:text-zinc-200 mb-2">휴지통으로 이동</h3>
          <p className="text-xs text-gray-500 dark:text-zinc-400 mb-6 leading-relaxed">
            <span className="font-semibold text-gray-700 dark:text-gray-300">{title}</span> 문서를 휴지통으로 이동하시겠습니까? <br/>하위 문서도 함께 접근이 차단됩니다.
          </p>
          <div className="flex justify-end space-x-2">
            <button onClick={onClose} className="px-4 py-2 text-xs font-medium text-gray-500 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-lg transition-colors">취소</button>
            <button onClick={onSubmit} className="px-4 py-2 text-xs font-medium bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors">삭제</button>
          </div>
        </div>
      </div>
    );
  }